import React, { Component } from 'react';
import NumericInput from 'react-numeric-input';

class HoursMinutesPicker extends Component {

    handleChangeHours = (value) => {
        this.props.handleChange(value, this.props.nbMinutes, this.props.name);
    }
    handleChangeMinutes = (value) => {
        this.props.handleChange(this.props.nbHours, value, this.props.name);
    }

    render() {
        return (
            <div style={{ display: 'flex', width: 100 }}>
                <NumericInput style={{ input: { width: 50 } }}
                    min={0} max={24} step={1} precision={0}
                    value={this.props.nbHours}
                    strict={true}
                    onChange={(value) => this.handleChangeHours(value)}
                />
                <NumericInput style={{ input: { width: 50 } }}
                    min={0} max={59} step={1} precision={0}
                    value={this.props.nbMinutes}
                    strict={true}
                    onChange={(value) => this.handleChangeMinutes(value)}
                />
            </div>
        )
    };
}

export default HoursMinutesPicker